import { render } from "./service_order.vue?vue&type=template&id=57592833&scoped=true&ts=true"
import script from "./service_order.vue?vue&type=script&lang=ts"
export * from "./service_order.vue?vue&type=script&lang=ts"

import "./service_order.vue?vue&type=style&index=0&id=57592833&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57592833"]])

export default __exports__